// extracted by css-extract-rspack-plugin
export default {"cls1":"ClaimDetails-cls1_uyi","cls2":"ClaimDetails-cls2_-KU ClaimDetails-cls1_uyi"};